import api from '@/api';
import { message } from 'antd';

let typesRaw = {
    SET_STATE: 'SET_STATE',
    RESET_ALL: 'RESET_ALL',
};


export const types = Object.keys(typesRaw).reduce((all, key) => ({
    ...all,
    [key]: `ITEMS/${typesRaw[ key ]}`,
}), {});


const initialState = {
    loading: false,
    saving: false,

    itemReservations: [],

	statusUpdateModalOpen: false,
	statusUpdateRow: null,
	statusUpdateSaving: false,
	statusUpdateValue: '',

    newReservationModalOpen: false,
	newReservationSaving: false,
	numberingGroupsList: [],
	numberingGroupsLoading: false,
};


export const reducers = (state = initialState, action) => {

    switch (action.type) {
        case types.SET_STATE:
        {
            return {...state, ...action.data };
        }

        case types.RESET_ALL:
        {
            return {...initialState };
        }

        default:
            return state;

    }
};

export default reducers;

const getErrorMessage = (err, fallback = 'Something went wrong') => {
	return err?.response?.data?.errors?.[0]
		|| err?.response?.data?.message
		|| err?.response?.data?.error
		|| err?.message
		|| fallback;
};

export const actions = {
    setState: (data) => ({ type: types.SET_STATE, data }),


    reset_all: () => ({ type: types.RESET_ALL }),

    load_numbering_groups: () => async (dispatch, getState) => {
        dispatch(actions.setState({
            numberingGroupsLoading: true,
        }));

        try {
            // Do not move these endpoints back under "/items/": ad blockers block that URL pattern
            const result = await api.get('/item-reservation/numbering-groups');

            dispatch(actions.setState({
                numberingGroupsList: result.numberingGroups || [],
                numberingGroupsLoading: false,
            }));
        } catch (err) {
            console.error('Error loading numbering groups', err);

            message.error(getErrorMessage(err, 'Unable to load numbering groups'));

            dispatch(actions.setState({
                numberingGroupsLoading: false,
            }));
        }
    },

    open_new_reservation_modal: () => async (dispatch, getState) => {
        dispatch(actions.setState({
            newReservationModalOpen: true,
        }));

        dispatch(actions.load_numbering_groups());
    },

    close_new_reservation_modal: () => async (dispatch, getState) => {
        dispatch(actions.setState({
            newReservationModalOpen: false,
            newReservationSaving: false,
        }));
    },

    get_reserved_part_numbers: (filters = {}) => async (dispatch, getState) => {
		dispatch(actions.setState({
			loading: true,
		}));

		try {
			const result = await api.get('/item-reservation/reserved-part-num', {
				params: {
					reservedPartNumberSearch: filters.reservedPartNumberSearch || '',
					descriptionSearch: filters.descriptionSearch || '',
				},
			});

			dispatch(actions.setState({
				itemReservations: result.item_reservations || [],
				loading: false,
			}));
		} catch (err) {
            console.error('Error reserved part numbers', err);
            message.error(getErrorMessage(err, 'Unable to get number reservations'));

			dispatch(actions.setState({
				loading: false,
			}));
		}
	},

    add_part_number: (reservation) => async (dispatch, getState) => {
        dispatch(actions.setState({
            newReservationSaving: true,
        }));

        try {

			await api.post('/item-reservation/reserve-part-num', {
				partReservation: {
					group_name: reservation.group_name,
					lead_digit: reservation.lead_digit,
					description: reservation.description || '',
				},
			});

            message.success('New part number reservation submitted successfully.');

            dispatch(actions.setState({
                newReservationModalOpen: false,
                newReservationSaving: false,
            }));

            dispatch(actions.get_reserved_part_numbers({
				"reservedPartNumberSearch": "",
				"descriptionSearch": ""
			}));

        } catch (err) {
            console.error('Error adding item number reservation', err);

            message.error(getErrorMessage(err, 'Unable to submit item number reservation'));

            dispatch(actions.setState({
                newReservationSaving: false,
            }));
        }
    },

	open_update_part_number_status_modal: (row) => async (dispatch, getState) => {
		dispatch(actions.setState({
			statusUpdateModalOpen: true,
			statusUpdateRow: row,
			statusUpdateValue: undefined,
		}));
	},

	close_update_part_number_status_modal: () => async (dispatch, getState) => {
		dispatch(actions.setState({
			statusUpdateModalOpen: false,
			statusUpdateRow: null,
			statusUpdateSaving: false,
			statusUpdateValue: undefined,
		}));
	},

	update_part_number_status: (row, newStatus) => async (dispatch, getState) => {
		if (!row) {
			message.error('No part number reservation was selected.');
			return;
		}

		if (row.U_TS_Status !== 'Reserved') {
			message.error('Only reserved part numbers can be updated.');
			return;
		}

		if (!newStatus) {
			message.error('Please select a status.');
			return;
		}

		if (!['Available', 'Cancelled'].includes(newStatus)) {
			message.error('Invalid status selected.');
			return;
		}

		dispatch(actions.setState({
			statusUpdateSaving: true,
		}));

		try {
			await api.post('/item-reservation/update-part-num', {
				partReservation: row,
				newStatus,
			});

			const successMessage = newStatus === 'Available'
				? `Reservation ${row.U_TS_Reserved_Part_Number} was unlocked.`
				: `Reservation ${row.U_TS_Reserved_Part_Number} was cancelled.`;

			message.success(successMessage);

			dispatch(actions.setState({
				statusUpdateModalOpen: false,
				statusUpdateRow: null,
				statusUpdateSaving: false,
				statusUpdateValue: undefined,
			}));

			dispatch(actions.get_reserved_part_numbers({
				reservedPartNumberSearch: '',
				descriptionSearch: '',
			}));
		} catch (err) {
			console.error('Error updating part number reservation status', err);

			message.error(getErrorMessage(err, 'Unable to update part number reservation status'));

			dispatch(actions.setState({
				statusUpdateSaving: false,
			}));
		}
	},
};
